/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_CustomizeInputs */

const en_common_customize = /** @type {(inputs: Common_CustomizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customize`)
};

const es_common_customize = /** @type {(inputs: Common_CustomizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalizar`)
};

/**
* | output |
* | --- |
* | "Customize" |
*
* @param {Common_CustomizeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_customize = /** @type {((inputs?: Common_CustomizeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_CustomizeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_customize(inputs)
	return en_common_customize(inputs)
});